import { type FC } from 'react'

import { arrowIcons } from './arrows'
import { brandIcons } from './brands'
import { characterIcons } from './character'
import { checkIcons } from './checks'
import { fileFormatIcons, getFileFormatIcon } from './fileFormats'
import { fileIcons } from './files'
import { mathIcons } from './math'
import { otherIcons } from './other'
import { statusIcons } from './status'
import { timeIcons } from './time'
import type { IconRootProps } from './types'

const icons = {
    ...fileFormatIcons,
    ...fileIcons,
    ...arrowIcons,
    ...mathIcons,
    ...characterIcons,
    ...otherIcons,
    ...brandIcons,
    ...checkIcons,
    ...statusIcons,
    ...timeIcons,
}

const IconRoot: FC<IconRootProps> = ({ name, ...rest }) => {
    const IconComponent = icons[name]

    if (!IconComponent) return null

    return <IconComponent {...rest} />
}

IconRoot.displayName = 'Icon'

export const Icon = Object.assign(IconRoot, icons)

export { getFileFormatIcon }
export default Icon
